export const WHATSAPP_NUMBER = "919909610001";

export function openWhatsAppInquiry(form, type = "Inquiry") {
  const lines = [
    `*New ${type} — KF Prints Website*`,
    "",
    `*Name:* ${form.name}`,
    form.company_name && `*Company:* ${form.company_name}`,
    `*Email:* ${form.email}`,
    form.phone && `*Phone:* ${form.phone}`,
    form.country && `*Country:* ${form.country}`,
    form.inquiry_details && `*Details:* ${form.inquiry_details}`,
  ].filter(Boolean);
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(lines.join("\n"))}`;
  window.open(url, "_blank", "noopener,noreferrer");
}
